import { Entity } from './EntitiesTypes';
import { ENTITIES_TYPES_ITEMS_CONFIG } from './EntitiesConsts';
import { ListItem, ListItemProps } from '@silverfort/sf-components';

export const mapEntitiesToItems = (entities: Entity[], listItemProps?: Partial<ListItemProps<Entity>>) => {
    return entities.map((entity) => (
        <ListItem
            key={entity.guid}
            title={
                entity.name + `${entity.is_disabled ? ' (disabled)' : ''}` + `${entity.is_deleted ? ' (deleted)' : ''}`
            }
            subtitle={`(${entity.domain_name})`}
            IconLeft={ENTITIES_TYPES_ITEMS_CONFIG[entity.type]?.icon}
            {...listItemProps}
            onClick={listItemProps?.onClick ? () => listItemProps?.onClick?.(entity) : undefined}
        />
    ));
};
